export default __webpack_public_path__ + "fc5b4eb3fc6578d27a74a8ab9d467ce5.svg";